module.exports = __webpack_public_path__ + "img/icon-政治@2x.be0c896d.png";